module.exports = "/_next/static/images/deepEnergyRetrofitting-6a91afad9a1ed8098bb77d2d86c5ce55.webp";